<app-base-modal
  [title]="viewDetails.modalTitleKey ?? 'shop-settings.content.global-editor.preview' | translate"
  class="large-modal"
>
  <article class="large-modal__body">
    <h4 class="large-modal__content-title">
      {{ viewDetails.titleKey | translate }}
    </h4>

    <div class="large-modal__content" [innerHTML]="viewDetails.text"></div>
  </article>

  <button class="large-modal__cancel-btn btn-primary" (click)="close()">
    {{ 'shop-settings.content.table.action-buttons.close' | translate }}
  </button>
</app-base-modal>
